import { Text } from '@zillow/constellation';
import { FAQ } from '@zillow/zrs-cms';
import PropTypes from 'prop-types';
import React from 'react';
import { generateBlockList } from '../../components/BlockList/BlockList.js';

var FAQItem = function FAQItem(_ref) {
  var index = _ref.index,
    _ref$attrs = _ref.attrs,
    heading = _ref$attrs.heading,
    id = _ref$attrs.id,
    innerBlocks = _ref.innerBlocks;
  return /*#__PURE__*/React.createElement(FAQ.Item, {
    as: "div",
    key: index,
    id: id
  }, /*#__PURE__*/React.createElement(FAQ.Header, {
    as: "dt"
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "h6"
  }, heading)), /*#__PURE__*/React.createElement(FAQ.Panel, {
    as: "dd"
  }, generateBlockList({
    blocks: innerBlocks
  })));
};
FAQItem.propTypes = process.env.NODE_ENV !== "production" ? {
  index: PropTypes.number,
  attrs: PropTypes.shape({
    heading: PropTypes.string,
    id: PropTypes.string
  }),
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({}))
} : {};
var FAQItem$1 = FAQItem;

export { FAQItem$1 as default };
